import { DescriptionRequestOptionsSelected } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'
import { Vue, Component, Prop, Ref, Emit } from 'vue-property-decorator'
import TextTemplatesModal from '@/components/description/TextTemplatesModal.vue'
import { UpdatedTextTemplate } from '@/modules/configurationModule/detail/local-samples/preformatted/shared/components/preformatted-editor-action-text-templates/preformatted-editor-action-text-templates.model'
import { TemplateRequestApplied } from '@/modules/configurationModule/detail/local-samples/preformatted/shared/components/preformatted-editor-action-synoptic-templates/preformatted-editor-action-synoptic-templates.model'
import { DescriptionResponseEditor, DescriptionResponseEnum } from '@/modules/configurationModule/detail/local-samples/preformatted/shared/components/preformatted-editor/preformatted-editor.model'

@Component({
    components: {
        TextTemplatesModal
    }
})
export default class PreformattedEditorActionTextTemplates extends Vue {
    @Prop() readonly description!: DescriptionResponseEditor
    @Prop() readonly laboratoryId!: number
    @Ref() readonly textTemplatesModal!: any
    @Emit()
    update(updatedTemplate: TemplateRequestApplied): TemplateRequestApplied {
        return updatedTemplate
    }

    get templateId(): number {
        return this.description.template?.id!
    }

    get optionsSelected(): DescriptionRequestOptionsSelected {
        return this.description.optionsSelected
    }

    applyTemplateChange(templateApplied: UpdatedTextTemplate): void {
        const updatedTemplate: TemplateRequestApplied = {
            text: templateApplied.text,
            descriptionType: DescriptionResponseEnum.TEXT_TEMPLATE,
            originalConcurrencyUpdatedAt: this.description.originalConcurrencyUpdatedAt,
            optionsSelected: templateApplied.optionsSelected,
            templateId: templateApplied.templateId,
            title: templateApplied.title,
            textEditingAllowed: templateApplied.textEditingAllowed
        }
        this.update(updatedTemplate)
    }

    showTemplatesModal(loadCurrentTemplateDetails: boolean = false): void {
        this.textTemplatesModal.show(loadCurrentTemplateDetails)
    }
}
